<template>
   <div id="container" class="container">

        <section class="intro demo" id="section01">
            <HeaderLogo></HeaderLogo>
            <div class="column-group nav container-block landscape">
                <div class="all-30 tiny-100 small-100 medium-100 vertical-space padding align-right sidebar-txt">
                    <div class="txt-title">
                        <span class="txt-style-1">Que </span>
                        <span class="txt-style-2">estrela FOX</span>
                        <br>
                        <span class="txt-style-3">podia partilhar casa contigo?</span>
                        <br>
                    </div>
                    <div class="txt-description all-100 push-right">
                        <p>Encontra a playlist da estrela FOX que tem tudo a ver contigo.
                            <br>Faz o quiz e descobre aqui com quem podias partilhar casa.

                        </p>
                        <!-- <div class="tiny-100 small-50 medium-50 large-100 xlarge-100 btn-home">
                            <button class="ink-button user login-spotify" @click="authenticate()" data-trackerlink="Geral|Content|Button_WithSpotify">Tenho Spotify</button>
                        </div> -->
                        <div class="tiny-100 small-50 medium-50 large-100 xlarge-100 btn-home">
                            <button class="ink-button trigger no-spotify" @click="doQuizAsGuest()" data-trackerlink= "Geral|Content|Button_WithoutSpotify">Começar Quiz</button>
                        </div>
                    </div>
                </div>
                <div class="all-70 tiny-100 small-100 medium-100 ">
                    <div class="gallery-wrap">
                        <div class="item item-1 effect-move">
                            <div class="content-overlay"></div>
                        </div>
                        <div class="item item-2">
                            <div class="content-overlay"></div>
                        </div>
                        <div class="item item-3">
                            <div class="content-overlay"></div>
                        </div>
                        <div class="item item-4">
                            <div class="content-overlay"></div>
                        </div>
                        <div class="item item-5">
                            <div class="content-overlay"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="intro__image"></div>
        </section>
    </div>
</template>

<script>
import SpotifyService from "@/services/spotify.service";

export default {
    name: "home",
    methods: {
        authenticate() {
            SpotifyService.isAuthenticated() ?
                this.$router.push({ name: "quiz", }) :
                SpotifyService.authenticate();
        },
        doQuizAsGuest(){
            SpotifyService.authenticateAsGuest().then(() => this.$router.push({ name: "quiz", }));
        }
    }
};
</script>
